import {StyleSheet} from 'react-native';
import {scaleFonts} from '@buncha/appStyles/style/font';

export const styles = StyleSheet.create({
  imageStyle: {
    height: scaleFonts(110),
    width: '100%',
    resizeMode: 'contain',
    alignSelf: 'center',
  },
  containerStyle: {
    borderRadius: 10,
    width: '100%',
    justifyContent: 'center',
    padding: 0,
  },
  bottomSheetImage: {
    height: '100%',
    width: '100%',
    resizeMode: 'contain',
    transform: [{rotate: '90deg'}],
  },
});
